import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { InputWithEmoji } from '../../../../../../../common/components/InputWithEmoji/InputWithEmoji';
import CheckBox from '../../../../../../../common/components/Checkbox';
import ChatbotModel, { MessagesSettings } from '@mm/state/model/ChatbotModel';

type Props = {
  bot: ChatbotModel;
  onBotChange: (bot: ChatbotModel) => void;
};

const INPUT_LABEL =
  'Message to send when the user does not pick a provided response';
const INPUT_PLACEHOLDER = 'Sorry, you must select one of the choices below.';

export const ResponseNotChosen = ({ bot, onBotChange }: Props) => {
  const [message, setMessage] = useState('');
  useEffect(() => setMessage(bot.responseNotChosenErrorMessage), [bot]);
  const updateMessage = () => {
    if (message === bot.responseNotChosenErrorMessage) {
      return;
    }
    onBotChange({ ...bot, responseNotChosenErrorMessage: message });
  };

  const onChangeCheckbox = () => {
    const messagesSettings = bot.messagesSettings || {
      disableMultipleChoiceValidation: false,
    };
    messagesSettings.disableMultipleChoiceValidation =
      !messagesSettings.disableMultipleChoiceValidation;

    onBotChange({
      ...bot,
      messagesSettings: messagesSettings as MessagesSettings,
    });
  };

  return (
    <div>
      <div className="bot-publishing-pane__logo-item-subtext">
        <CheckBox
          isChecked={
            !get(bot, 'messagesSettings.disableMultipleChoiceValidation')
          }
          label={INPUT_LABEL}
          className="bot-system-messages__checkbox"
          onToggle={onChangeCheckbox}
        />
      </div>
      <InputWithEmoji
        placeholder={INPUT_PLACEHOLDER}
        maxLength={100}
        value={message}
        onChange={setMessage}
        onBlur={updateMessage}
        disabled={
          !!get(bot, 'messagesSettings.disableMultipleChoiceValidation')
        }
      />
    </div>
  );
};
